import React from 'react'

import AceEditor from "react-ace";

import "ace-builds/src-noconflict/mode-java";
import "ace-builds/src-noconflict/theme-github";

import PortalModal from './PortalModal';
import Border from '../Border';
import Collapsible from 'react-collapsible';
import Dropdown from '../Dropdown';
import LinkSelect from "../LinkSelect";
import IconPickerGrid from '../IconPickerGrid';
import Toggle from '../sectioninputs/Toggle';
import General from "../../utils/General";
import LayoutEditor from "../LayoutEditor";
import ColorPicker from '../ColorPicker';
import AsyncSelect from "../common/CCAsyncSelect";
import Backend from "../../utils/Backend";
import Cart from "../../utils/Cart";
import DefaultData from "../../utils/DefaultData";
import ProductDetailSettings, { DEFAULT_VISIBILITY, VISIBILITY_MAP, visibilityStyles } from "../ProductDetailSettings";
import DrawerCartSettings from "../DrawerCartSettings";
import ProductCardColorSwatchSettings from '../ProductCardColorSwatchSettings';
import { productSettingsIds } from '../constants/general';
import { RangeSlider } from './PopupManagerModal';
import { getCleanedPixelValue, storefrontPopupDeviceTypesCollection } from '../constants/storefrontPopupConstants';
import { PRODUCT_WIDTH } from '../ProductDetailSettingsConfig';

const OPTIONS_BORDER_RADIUS = [
  { label: 'Square', value: '0px' },
  { label: 'Rounded', value: '6px' }
];
const OPTIONS_DISCOUNT= [
  { label: 'Amount', value: 'price' },
  { label: 'Percentage', value: 'percent' },
  { label: 'Amount & Percentage', value: 'both' },
]
const SETTINGS_CONFIG = {
  // 1. BREADCRUMBS
  breadCrumbsOptions: {
    label: 'Breadcrumbs (Global)',
    id: 'breadCrumbsOptions',
    fields: [
      {
        type: 'dropdown',
        label: 'Border Style',
        key: 'breadCrumbs_border_style',
        options: OPTIONS_BORDER_RADIUS
      },
      {
        type: 'colorPicker',
        title: 'Border color',
        key: 'breadCrumbs_border_color'
      },
      {
        type: 'colorPicker',
        title: 'Background color',
        key: 'breadCrumbs_background_color'
      },
      {
        type: 'colorPicker',
        title: 'Link color',
        key: 'breadCrumbs_link_color'
      },
      {
        type: 'colorPicker',
        title: 'Carrot color',
        key: 'breadCrumbs_carrot_color'
      },
      {
        type: 'colorPicker',
        title: 'Text color',
        key: 'breadCrumbs_text_color'
      },
      {
        type: 'dropdown',
        label: 'Width',
        key: 'breadCrumbs_width',
        options: PRODUCT_WIDTH
      },
      {
        type: 'rangeSlider',
        label: 'Padding',
        key: 'breadCrumbs_padding',
        min: 0,
        max: 35,
        step: 1
      },
      {
        type: 'visibilityToggles',
        label: 'Visibility',
        key: 'visibility'
      }
    ]
  }
}
const settingOptions = Object.keys(SETTINGS_CONFIG).map(key => ({
  value: key,
  label: SETTINGS_CONFIG[key].label,
  id: SETTINGS_CONFIG[key].id
}));
export default class ProductSettingsModal extends React.Component {
  constructor(props){
    super(props)
    this.state = {
      show: props.show,
      layoutOrder: this.getInitialLayout(props),
      data: props.website.extra?.product_page_settings || {
        ...DefaultData.PRODUCT_PAGE_SETTINGS,
        layoutOrder: this.getInitialLayout(props)
      },
      selectedSetting: "breadCrumbsOptions"
    }
  }

  componentWillReceiveProps(nextProps){
    this.setState({
      ...nextProps,
      layoutOrder: this.getInitialLayout(nextProps)
    });
  }

  getInitialLayout = (props) => {
    return props.website.extra?.product_page_settings?.layoutOrder || [...DefaultData.PRODUCT_PAGE_LAYOUT];
  };
renderDropdown = (field, index) => {
    return (<div key={index} className="mb-3">
      <span className="d-block mb-2">{field.label}</span>
      <Dropdown
        options={field.options}
        value={field.options.find(opt => opt.value === this.state.data[field.key])}
        onChange={(option) => {
            const { data } = this.state;
            data[field.key] = option.value;
            this.props.onUpdated(data);
        }}
        placeholder="Select An Option"
      />
    </div>)
  };
  renderColorPicker = (field, index) => {
    return (
      <div key={index} className="mb-3">
        <ColorPicker
          title={field.title}
          color={this.state.data[field.key] || ''}
          onColorSelected={(color) => {
            const { data } = this.state;
            data[field.key] = color;
            this.props.onUpdated(data);
          }}
        />
      </div>
    );
  };

  renderRangeSlider = (field, index) => {
    return (<div key={index}>
      <RangeSlider
        label={field.label}
        min={field.min}
        max={field.max}
        step={field.step}
        value={getCleanedPixelValue(this.state.data[field.key]) || 0}
        onChange={(propertyName, value) => {
            const { data } = this.state;
            data[field.key] = `${value}px`;
            this.props.onUpdated(data);
        }}
        propertyName={field.key}
        labelClassName="storefront-popup-settings-sub-heading"
      />
    </div>)
  };
  _ensureComponentVisibility() {
      const  {data, selectedSetting } = this.state;
      const nextData = {...data};
      nextData.visibility = nextData.visibility || {};
      const visibilityKey = VISIBILITY_MAP[selectedSetting];
      if (visibilityKey) {
        nextData.visibility[visibilityKey] = {
          ...DEFAULT_VISIBILITY,
          ...(nextData.visibility[visibilityKey] || {})
        }
      }
      return nextData;
    }
    _updateComponentVisibility (device, checked) {
      const { selectedSetting } = this.state;
      const visibilityKey = VISIBILITY_MAP[selectedSetting];
      if (!visibilityKey) return;
      const  nextData = this._ensureComponentVisibility();
      nextData.visibility[visibilityKey]= {
        ...nextData.visibility[visibilityKey],
        [device] : !!checked
      }
      this.setState({ data: nextData }, () => {
        this.props.onUpdated(nextData);
        setTimeout(() => {
          General.updateAll();
          try {
            window.dispatchEvent(new Event('resize'));
          } catch (e) {}
        }, 0);
      })
    }
  _renderToggles(field) {
      const { data, selectedSetting } = this.state;
      const visibilityKey = VISIBILITY_MAP[selectedSetting];
      const visibility = {
        ...DEFAULT_VISIBILITY,
        ...(data?.visibility?.[visibilityKey] || {})
      }
      const handleToggle = this._updateComponentVisibility.bind(this);
      return (
        <>
          <span className="d-block mb-2">{field.label}</span>
          <div className='d-flex justify-content-around mt-3'>
            {storefrontPopupDeviceTypesCollection.map((item, idx) => {
              const isVisible = visibility[item.device];
              return (
                <div
                  key={idx}
                  className="storefront-popup-settings-toggle"
                  style={visibilityStyles.container}
                  onClick={() => handleToggle(item.device, !isVisible)}
                  title={`${item.deviceName}: ${isVisible ? 'Visible' : 'Hidden'}`}
                >
                  <div style={visibilityStyles.iconWrapper(isVisible)}>
                    <div 
                      style={visibilityStyles.icon(isVisible)}
                      dangerouslySetInnerHTML={{ __html: item.svg }}
                    />
                    {isVisible && (
                      <div style={visibilityStyles.checkmark}>
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="white">
                          <path d="M2 5 L4 7 L8 3" stroke="white" strokeWidth="1.5" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                      </div>
                    )}
                  </div>
                </div>
              )
            })}
          </div>
          <br/>
        </>
      );
    }
  _renderHTML(key){
    let { data } = this.state

    let htmlBody = data[key]

    let lazyLoad = data[`${key}_lazy_load`]

    const openSection = this.props.openProductSettingsSection === productSettingsIds.htmlBlock

    return (
      <Border>
        <Collapsible
          trigger={"Code"}
          open={openSection}
        >
          <br/>
          <span>Enter your custom HTML/CSS/JS here</span>
          <br/>
          <a
            href="https://help.checkoutchamp.com/funnel-builder/creating-and-editing-funnels-pages/funnel-visualizer-and-page-builder/storefront/customization/html-blocks-and-code-sections"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              fontSize: "12px",
              color: "#007bff",
              textDecoration: "underline",
              display: "inline-flex",
              alignItems: "center"
            }}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              style={{ marginRight: "4px" }}
              className="lucide lucide-book-open"
            >
              <path d="M12 7v14" />
              <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
            </svg>
            View Help Doc
          </a>
          <br/>
          <div
            style={{
              width: "100%",
              padding: 8,
              backgroundColor: "#f5f5f5"
            }}
          >
            <AceEditor
              mode="javascript"
              theme="xcode"
              style={{width: "100%", backgroundColor: "transparent"}}
              defaultValue={htmlBody}
              showGutter={false}
              debounceChangePeriod={1000}
              onChange={body => {
                data[key] = body
                this.props.onUpdated(data)
              }}
            />
          </div>
          <br/>
          <div className="row align-items-center">
            <div className="col-md-8">
              <h4 className='lh-1 mb-0'>
                Lazy Load<br></br>
                <small className='fs-12 lh-1'>
                  Only trigger code when section comes into view
                </small>
              </h4>
            </div>
            <div className="col-md-4 text-right">
              <div className="input-checkbox input-checkbox--switch">
                <input
                  id="custom_block_variation"
                  type="checkbox"
                  defaultChecked={lazyLoad}
                  onChange={(e) => {
                    if (e.target.checked) {
                      data[`${key}_lazy_load`] = true
                    } else {
                      data[`${key}_lazy_load`] = false
                    }
                    this.props.onUpdated(data)
                  }}
                />
                <label htmlFor="custom_block_variation"></label>
              </div>
            </div>
          </div>
        </Collapsible>
      </Border>
    )
  }

  _checkoutSettings() {
    let { data } = this.state

    let OPTIONS = [
      {
        value: "instant",
        label: "Instant Checkout"
      },
      {
        value: "cart",
        label: "Cart Based Checkout"
      },
      {
        value: "instantAndCart",
        label: "Instant and Cart Based Checkout"
      }
    ]
    return (
      <Border>
        <Collapsible
          trigger={`Checkout`}
          open={this.props.openProductSettingsSection === productSettingsIds.addToCartAndBuyNowBtn}
        >
          <br/>
          <span>Checkout experience</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === this.props.website.checkout_type
            )}
            onChange={option => {
              this.props.onCheckoutTypeUpdated(option.value)
            }}
            placeholder="Select An Option"
          />
          <br/>
          <span>Link your checkout page</span>
          <LinkSelect
            type={"shop"}
            checkoutOnly={true}
            url={data.checkout_url}
            onUpdated={(url) => {
              data.checkout_url = url
              this.props.onUpdated(data)
            }}
          />
        </Collapsible>
      </Border>
    )
  }
  _collectionColorSwatchSettings() {
    let { data } = this.state
    const colorSwatchComponentPropData = {
      extra: {
        product_tile_color_swatch: data?.collection_product_tile_color_swatch,
        display_product_tile_color_swatch: data?.display_collection_product_tile_color_swatch
      }
    }
    return (
      <ProductCardColorSwatchSettings
        data={colorSwatchComponentPropData}
        update={(obj) => {
          const colorSwatchData = obj?.data
          data.collection_product_tile_color_swatch = colorSwatchData?.extra?.product_tile_color_swatch
          data.display_collection_product_tile_color_swatch = colorSwatchData?.extra?.display_product_tile_color_swatch
          this.props.onUpdated(data)
        }}
      />
    )
  }
  _tileSettings() {
    let { data } = this.state

    return (
      <Border>
        <Collapsible
          trigger={`Product Tile`}
        >
          <br/>
          <Toggle
            id="description_toggle"
            checked={data?.show_description || false}
            title="Description"
            onChange={checked => {
              data.show_description = checked;
              this.props.onUpdated(data)
            }}
          />
        </Collapsible>
      </Border>
    )
  }
  _productsPerPage() {
    let { data } = this.state

    let OPTIONS = [
      {
        value: 6,
        label: "6 Products"
      },
      {
        value: 12,
        label: "12 Products"
      },
      {
        value: 18,
        label: "18 Products"
      },
      {
        value: 24,
        label: "24 Products"
      }
    ]

    let productPageCount = data.product_page_count || 18

    return (
      <Border>
        <Collapsible
          trigger={`# of Products Per Page`}
        >
          <br/>
          <span>The number of products to display</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === productPageCount
            )}
            onChange={option => {
              data.product_page_count = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
          <br/>
          <Toggle
            id="pagination_toggle"
            checked={data?.show_pagination == false ? false : true}
            title="Paginate"
            onChange={checked => {
              data.show_pagination = checked;
              this.props.onUpdated(data)
            }}
          />
        </Collapsible>
      </Border>
    )
  }

  _noOfColumns() {
    let { data } = this.state

    let OPTIONS = [
      {
        value: 2,
        label: "2 Columns"
      },
      {
        value: 3,
        label: "3 Columns"
      },
      {
        value: 4,
        label: "4 Columns"
      }
    ]

    let columnNo = data.columns_no || 3

    return (
      <Border>
        <Collapsible
          trigger={`# of Columns`}
        >
          <br/>
          <span>The number of columns to display</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === columnNo
            )}
            onChange={option => {
              data.column_no = option.value
              this.props.onUpdated(data)
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }
renderSelectedSettings = () => {
  const config = SETTINGS_CONFIG["breadCrumbsOptions"];
  
  if (!config) return null;
  return (
    <>
      <br />
      {config.fields.map((field, index) => this.renderField(field, index))}
    </>
  );
};
renderField = (field, index) => {
    switch (field.type) {
      case 'dropdown':
        return this.renderDropdown(field, index);
      
      case 'colorPicker':
        return this.renderColorPicker(field, index);
      
      case 'rangeSlider':
        return this.renderRangeSlider(field, index);

      case 'visibilityToggles':
        return this._renderToggles(field, index);
      
      default:
        return null;
    }
  };
  _collectionStyleSettings() {
    let { data } = this.state;
    
    return (
      <Border>
        <Collapsible trigger={`Style Settings`}>
          <br/>
          <div className="dynamic-product-settings">
            <div className="mb-4">
              <Dropdown
                options={settingOptions}
                value={settingOptions.find(opt => opt.id === "breadCrumbsOptions")}
                onChange={(option) => this.setState({ selectedSetting: option.id })}
                placeholder="Select a setting to configure"
              />
            </div>
            
            <div className="settings-content mt-4">
              {this.renderSelectedSettings()}
            </div>
          </div>
          <ColorPicker
            title="Body Background Color"
            color={data.collection_body_bg_color}
            onColorSelected={(color) => {
              data["collection_body_bg_color"] = color;
              this.props.onUpdated(data);
            }}
          />
          <ColorPicker
            title="Text color"
            color={data.collection_text_color}
            onColorSelected={(color) => {
              data["collection_text_color"] = color;
              this.props.onUpdated(data);
            }}
          />
        </Collapsible>
      </Border>
    )
  }
  _cartIconRoute() {
    let { data } = this.state

    let OPTIONS = [
      {
        value: "modal",
        label: "Cart Drawer"
      },
      {
        value: "page",
        label: "Cart Page"
      }
    ]

    let cartIconRoute = data.cart_icon_route || "modal"

    return (
      <Border>
        <Collapsible
          trigger={`Cart Icon Route`}
        >
          <br/>
          <span>Where should the cart icon route to?</span>
          <Dropdown
            options={OPTIONS}
            value={OPTIONS.find(
              (mode) => mode.value === cartIconRoute
            )}
            onChange={option => {
              data.cart_icon_route = option.value
              this.setState({
                data
              }, () => this.props.onUpdated(data))
            }}
            placeholder="Select An Option"
          />
        </Collapsible>
      </Border>
    )
  }

  _cartDrawerSettings() {
    let { data } = this.state

    return (
      <>
        <DrawerCartSettings
          data={data}
          onUpdated={settings => {
            data = settings
            this.setState({
              data
            }, () => this.props.onUpdated(data))
          }}
        />
      </>
    )
  }
  _cartStyleSettings() {
    let { data } = this.state
    return (
      <Border>
        <Collapsible
          trigger={`Cart Page Styles`}
        >
          <b><span>Body</span></b>
          <div className="mb-3">
            <span className="d-block mb-2">Border Style</span>
            <Dropdown
              options={OPTIONS_BORDER_RADIUS}
              value={OPTIONS_BORDER_RADIUS.find(
                (opt) => opt.value === data["body_border_style"]
              )}
              onChange={(option) => {
                data["body_border_style"] = option.value;
                this.props.onUpdated(data);
              }}
              placeholder="Select An Option"
            />
          </div>
          <ColorPicker
            title="Border color"
            color={data.body_border_color}
            onColorSelected={(color) => {
              data["body_border_color"] = color;
              this.props.onUpdated(data);
            }}
          />
          <ColorPicker
            title="Background color"
            color={data.body_bg_color}
            onColorSelected={(color) => {
              data["body_bg_color"] = color;
              this.props.onUpdated(data);
            }}
          />
          <b><span>Cart</span></b>
          <RangeSlider
            label={"Cart Padding"}
            min={0}
            max={35}
            step={1}
            value={getCleanedPixelValue(data["cart_padding"]) || 0}
            onChange={(propertyName, value) => {
              data["cart_padding"] = `${value}px`;
              this.props.onUpdated(data);
            }}
            propertyName="padding"
            labelClassName="storefront-popup-settings-sub-heading"
          />
          <ColorPicker
            title="Cart Background color"
            color={data.cart_bg_color}
            onColorSelected={(color) => {
              data["cart_bg_color"] = color;
              this.props.onUpdated(data);
            }}
          />
          <ColorPicker
            title="Text color"
            color={data.cart_text_color}
            onColorSelected={(color) => {
              data["cart_text_color"] = color;
              this.props.onUpdated(data);
            }}
          />
          <ColorPicker
            title="Price color"
            color={data.cart_price_color}
            onColorSelected={(color) => {
              data["cart_price_color"] = color;
              this.props.onUpdated(data);
            }}
          />
          <ColorPicker
            title="Label color"
            color={data.cart_label_color}
            onColorSelected={(color) => {
              data["cart_label_color"] = color;
              this.props.onUpdated(data);
            }}
          />
          <ColorPicker
            title="Sub-Label color"
            color={data.cart_sub_label_color}
            onColorSelected={(color) => {
              data["cart_sub_label_color"] = color;
              this.props.onUpdated(data);
            }}
          />
          <ColorPicker
            title="Divider color"
            color={data.cart_divider_color}
            onColorSelected={(color) => {
              data["cart_divider_color"] = color;
              this.props.onUpdated(data);
            }}
          />
        </Collapsible>
      </Border>
    )
  }
  _getProductOption(product){
    if(!product){
      return null
    }

    return {
      label: product.productName,
      value: product.productId,
      data: product
    }
  }

  _cartPageProduct() {
    let { data } = this.state

    return (
      <Border>
        <Collapsible trigger="Order Bump">
          <br />
          <AsyncSelect
            endpoint={window.CCApi.Products}
            classNamePrefix="async-select-paginate"
            placeholder="Please Select A Product"
            noOptionsMessage={() => "No Products Found"}
            value={this._getProductOption(data.cart_page_product)}
            onSelected={product => {
              data.cart_page_product = product;
              this.setState({ data }, () => {
                this.props.onUpdated(data)
              })
            }}
            getOptions={options => options.map(option => this._getProductOption(option[1]))}
          />
        </Collapsible>
      </Border>
    )
  }

  render() {
    let {
      show,
      data
    } = this.state

    const {
      subscribeAndSaveSettings,
      updateSubscribeAndSaveSettings
    } = this.props;

    const productPage = window.location.pathname.includes("/product")
    const cartPage = window.location.pathname.includes("/cart")

    const title = productPage ? "product" : cartPage ? "cart" : "collection"

    let imgTileVariantType = ""

    const variantTypeIndexes = [1, 2, 3]

    variantTypeIndexes.forEach((item) => {
      const key = `variant${item}_style`
      if (data[key] === "img_tile") {
        imgTileVariantType = key
      }
    })

     return (
      <PortalModal
        show={show}
        loadSideMenuFromLeft="true"
        onHide={() => this.props.onHide()}
      >
        <h2 className="mb-0">
          {General.toTitleCase(title)} Page Settings
        </h2>
        <label className="mb-5">Adjust your {title} page core style</label>

        {
          productPage &&
          <>
            {this._checkoutSettings()}

            <ProductDetailSettings
              openProductSettingsSection={this.props.openProductSettingsSection}
              defaultIndex={this.props.defaultIndex}
              show={this.props.show}
              data={data}
              subscribeAndSaveSettings={subscribeAndSaveSettings}
              onUpdated={(data) => {
                this.setState({
                  data
                }, () => this.props.onUpdated(data))
              }}
              updateSubscribeAndSaveSettings={updateSubscribeAndSaveSettings}
            />

            {this._renderHTML("product_page_html")}
          </>
        }

        {
          cartPage &&
          <>
            {this._checkoutSettings()}

            {this._cartIconRoute()}

            {this._cartDrawerSettings()}

            {this._cartPageProduct()}

            {this._cartStyleSettings()}

            {this._renderHTML("cart_page_html")}

          </>
        }

        {
          (!productPage && !cartPage) &&
          <>
            {this._checkoutSettings()}

            {this._tileSettings()}

            {this._collectionColorSwatchSettings()}

            {this._cartIconRoute()}

            {this._productsPerPage()}

            {this._noOfColumns()}
             
            {this._collectionStyleSettings()}
          </>
        }


      </PortalModal>
    )
  }
}
